// storybook-check-ignore
import React from 'react';

import { css } from '@emotion/react';
import Box from '@opendoor/bricks/core/Box';

import type { MenuLink } from '../types';
import { NavLink } from './NavLink';

interface NavigationLinksProps {
  mainNavLinks: MenuLink[];
  slug: string;
  tabletDisplay: 'flex' | null;
}

export const NavigationLinks: React.FC<NavigationLinksProps> = ({
  mainNavLinks,
  slug,
  tabletDisplay,
}) => {
  return (
    <Box gridColumn="1 / -1" gridRow="1 / 2">
      <Box
        as="ul"
        m="0"
        p="0"
        display={['none', null, tabletDisplay, 'flex']}
        justifyContent="center"
        analyticsName="cosmos-landing-page-menu-list"
        css={css`
          list-style: none;
        `}
      >
        {mainNavLinks.map((nav) => {
          return (
            <Box as="li" key={nav.name}>
              <NavLink active={slug === nav.href} href={nav.href} name={nav.name}>
                {nav.name}
              </NavLink>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
